import EditEmployeeDialog from './editEmployeeDialog.container'

export default EditEmployeeDialog